export const iconFontAwesomeCampingBucket = (
	<i className="fa-solid fa-bucket"></i>
);
